import {ObjUtil} from 'yougile-util'
import {
  DataObjectId,
  SandboxTree,
  StickerData,
  stickerDataFromTag
} from 'yougile-model'
import {Project} from '../project'
import {Sticker} from './sticker'

export const getAllStickers = (
  box: SandboxTree,
  onlyInBoards: boolean
): StickerData[] => {
  const res = Sticker.list(box)
    .map(s => stickerDataFromTag(s))
    .filter(s => !!s && !s.deleted)
  if (!onlyInBoards) {
    return res
  }
  const inBoards: Set<DataObjectId> = new Set()
  Project.listProjects(box.companyId, 'not-archive').forEach(p => {
    Project.listBoards(p, false).forEach(b => {
      ObjUtil.forEach(b.stickers, (id: DataObjectId) => inBoards.add(id))
    })
  })
  return res.filter(st => {
    return (
      st &&
      (st.isSystem ||
        (inBoards.has(st.id) && Object.keys(st.states ?? {}).length > 0))
    )
  })
}
